import type { NoticesSlice, NoticesState, ViewerSliceCreator } from "./types";

export const noticesInitialState: NoticesState = {
  notices: [],
};

let nextNoticeId = 1;

export const createNoticesSlice: ViewerSliceCreator<NoticesSlice> = (set) => ({
  ...noticesInitialState,

  pushNotice: (message) =>
    set((state) => {
      state.notices.push({ id: nextNoticeId++, level: message.level, text: message.text, at: Date.now() });
      // Keep the stack short; old ones have been read or missed either way.
      if (state.notices.length > 5) state.notices.splice(0, state.notices.length - 5);
    }),

  dismissNotice: (id) =>
    set((state) => {
      state.notices = state.notices.filter((n) => n.id !== id);
    }),
});
